module.exports = __webpack_public_path__ + "static/media/home.55ed23b6.svg";